import numeral from 'numeral';
import axios from 'axios';

require('numeral/locales/en-gb');

axios.get('/api/app-v1/locale').then((response) => {
    numeral.register('locale', 'eventworks', response.data);
    numeral.locale('eventworks');
}).catch(() => {
    numeral.locale('en-gb');
});

